import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import { entityContextPath, entityContextPermissions } from 'features/genericEntityFlow/utils';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import { usePermissions } from 'providers/RightsHooks';
import IconButton from 'components/common/buttons/IconButton';
import TextTableCell from 'components/common/table/TextTableCell';
import CheckboxTableCell from 'components/common/table/CheckboxTableCell';
import ActionsTableCell from 'components/common/table/ActionsTableCell';

const GenericEntityFlowItem = ({ data, onDelete }) => {
  const historyContext = useHistoryWithContext();

  const canWrite = usePermissions(entityContextPermissions[data.context]?.write);

  const handleEdit = useCallback(() => {
    historyContext.push(`/${entityContextPath[data.context]}/${data.id}`);
  }, [historyContext, data]);

  return (
    <TableRow key={data.id}>
      <TextTableCell content={data.flowCode} />
      <TextTableCell content={data.flowName} />
      <TextTableCell content={data.freeTxt} />
      <CheckboxTableCell checked={data.enabledYN} />
      <CheckboxTableCell checked={data.mainFlow} />
      <ActionsTableCell>
        <IconButton type={canWrite ? 'edit' : 'view'} onClick={handleEdit} />
        {canWrite && <IconButton type='delete' onClick={() => onDelete(data.id)} />}
      </ActionsTableCell>
    </TableRow>
  );
};

GenericEntityFlowItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func
};

export default GenericEntityFlowItem;
